/* RESPONSIBLE TEAM: team-frontend-tech */
import Service from '@ember/service';
import { getOwner } from '@ember/application';
import { tracked } from '@glimmer/tracking';
import type ApplicationInstance from '@ember/application/instance';

export default class ModalService extends Service {
  @tracked isModalOpen = false;
  @tracked modalComponentModel: $TSFixMe | null = null;
  @tracked modalComponent: string | null = null;
  @tracked modalOptions: { canCloseModal: boolean } | null = null;
  canCloseModal = true;

  openModal(componentName: string, model: $TSFixMe, options?: $TSFixMe) {
    this.modalComponent = componentName;
    this.modalComponentModel = model;
    this.isModalOpen = true;
    this.modalOptions = options;
    this.canCloseModal = options?.canCloseModal ?? true;
    this.owner.lookup('route:application').send('openModal', ...arguments);
  }

  closeModal(results: $TSFixMe = {}) {
    if (!this.canCloseModal) {
      return;
    }
    this.owner.lookup('route:application').send('closeModal', results);
    this.owner.lookup('route:application').send('warnOnNavigation', false);
    this.isModalOpen = false;
    this.modalComponent = null;
    this.modalComponentModel = null;
    this.modalOptions = null;
    this.canCloseModal = true;
  }

  private get owner(): ApplicationInstance {
    return getOwner(this) as ApplicationInstance;
  }
}
